$(document).ready(function () {
    /**
     * VideoJS
     * show button 2 minutes after video starts
     */
    if ($('#vitalRedsVSL').length) {
        videojs('vitalRedsVSL').ready(function () {
            this.on('timeupdate', function () {
                if (this.currentTime() >= (60 * 2) || this.currentTime() == this.duration()) {
                    $('.topSection .btn').removeClass('invisible');
                }
                // console.log(this.currentTime());
            })
        });
    };

    /**
     * Scroll to Cart
     */
    if($('#salesBanner').length) {
        let salesBannerHeight = Math.floor($('#salesBanner').height());

        if($('#salesBanner').hasClass('isSticky')) {
            
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - salesBannerHeight
                }, 1000);
            });
        } else {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            });
        }
    } else {
        $('.btn:not(.cta)').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        });
    }

    /**
     * Typewriter
     */
    $("#typewriterText").typed({
        strings: [
            // 'Enhanced Bio - Energy*<sup>†</sup>',
            'Healthy-Looking Skin*<sup>†</sup>',
            'Energy From Better Digestion*<sup>†</sup>',
            'Less Gas and Bloating After Meals*<sup>†</sup>',
            'Smooth Bowel Movements*<sup>†</sup>',
            'Support to Help Manage Your Weight*<sup>†</sup>'
        ],
        // stringsElement: '#content',
        // Optionally use an HTML element to grab strings from (must wrap each string in a <p>)
        // stringsElement: null,
        // typing speed
        typeSpeed: 10,
        // time before typing starts
        startDelay: 900,
        // backspacing speed
        backSpeed: 5,
        // time before backspacing
        backDelay: 500,
        // loop
        loop: true,
        // false = infinite
        loopCount: false,
        // show cursor
        showCursor: true,
        // character for cursor
        cursorChar: "|",
        // attribute to type (null == text)
        attr: null,
        // either html or text
        contentType: 'html',
        // call when done callback function
        callback: function () { },
        // starting callback function before each string
        preStringTyped: function preStringTyped(pos, self) {
            // console.log('arrayPos', pos );
            $('#typewriterIcons .icon-wrap').removeClass('start');

            $('#typewriterIcons .icon-wrap:nth-child(' + (pos + 1) + ')').addClass('start');
            //   $('.product-img').addClass('start');

        },
        //callback for every typed string
        // onStringTyped: function () {
        //   $('.product-img').removeClass('start'); 

        // },
        // callback for reset
        resetCallback: function () { }
    });

    /**
     * Handle products
     */
    const
        body = $('body'),
        disclaimerBox = $('#disclaimerBox'),
        disclaimerTrigger = $('#disclaimerTrigger'),
        subscribeMode = $('#subscribeMode');

    //- Select Subscribe option if click on disclaimer box title
    disclaimerTrigger.on("click", function () {
        let checkbox = $('#subscribeCheckbox');
        let cartBtn = $('#cartCta');

        checkbox.toggleClass('checked');
        cartBtn.toggleClass('disabled');
    });

    // close disclaimer box
    $('#closeDisclaimer').on('click', function () {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    });

    // Subscribe Mode
    $('.subscribe-box__default').on('click', function () {
        let thisBtn = $(this);
        let cartBtn = $('#cartCta');
        let checkbox = $('#subscribeCheckbox');

        $('.subscribe-box__default').removeClass('active');
        thisBtn.addClass('active');

        disclaimerBox.addClass('subscribe-box__disclaimer--open');

        //- reset all UIs
        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (checkbox.hasClass('checked')) {
            checkbox.removeClass('checked');
        }

        //- set 'data-subscribe' value + control UI
        if (thisBtn.hasClass('subscribe')) {
            subscribeMode.attr('data-subscribe', 'true');

            if (!cartBtn.hasClass('disabled')) {
                cartBtn.addClass('disabled');
            }

            if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.addClass('subscribe-box__disclaimer--open');
            }

        } else {
            subscribeMode.attr('data-subscribe', 'false');

            if (cartBtn.hasClass('disabled')) {
                cartBtn.removeClass('disabled');
            }

            if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.removeClass('subscribe-box__disclaimer--open');
            }
        }

        $('.cart__product.active').trigger("click");
    });

    function activeProduct() {
        let thisProduct = $(this);
        let subscribeAttr = $('#subscribeMode').attr('data-subscribe');

        const retail = thisProduct.attr('data-retail');

        let price, regularity, link, subscribeSave, shipping, alternativeContentValue,
            unit = thisProduct.attr('data-units'),
            badge = thisProduct.attr('data-stamp');

        if (subscribeAttr === 'true') {
            price = 'data-subscribe-amount';
            regularity = '<span>/month</span>';
            shipping = 'data-subscribe-shipping';
            link = 'data-subscribe-tracker';
            alternativeContentValue = '';
            
        } else {
            price = 'data-amount';
            regularity = '';
            shipping = 'data-shipping',
            link = 'data-tracker';
            alternativeContentValue = $('#alternativeContent').attr('data-alt-content');
        }
        
        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');
        
        $('.current__value').html(thisProduct.attr(price) + regularity);
        $('.retail__value').html(retail);
        $('.shipping__value').html((thisProduct.attr(shipping)));
        
        $('#alternativeContent').html(' ' + alternativeContentValue);

        if (unit == '3' || unit == '6') {
            if (!$('.shipping').hasClass('hide')) {
                $('.shipping').addClass('hide');
            }
        } else {
            $('.shipping').removeClass('hide');
        }

        if (unit == '1' && subscribeAttr === 'true') {
            subscribeSave = 'data-subscribe-save';

            $('.saving__value').html(thisProduct.attr(subscribeSave));
        } else {
            $('.saving__value').html((retail - thisProduct.attr(price)).toFixed(2));
        }

        // Images to show according to the product unit
        $('.cart__image-item').removeClass('show').addClass('hide');
        $('.cart__image-item--' + unit + "").removeClass('hide').addClass('show');

        //- prints Best value per package
        if ($('#ribbon').length) {
            $('.ribbon__value').html(badge);
        }

        //- handle CTA by ID
        let param = $('#cartCta').attr('data-param');
        $('#cartCta').attr('href', thisProduct.attr(link) + param);
    }

    $('.cart__product').on('click', activeProduct);
    $('.cart__product.active').trigger("click");

    /**
     * Handle accordion on desktop to open 2 sections at a time
     */
    function accordionUI() {
        const accordion = $('#accordionKeyBenefits');
        let accordionTriggers = accordion.find('.accordion__title');
        let accordionContent = accordion.find('.accordion__body');
        // console.log(accordionTriggers.length);

        //- working but not scalable
        accordionTriggers.each(function (i) {
            let item = $(accordionTriggers[i]);
            let content = $(accordionContent[i]);

            // console.log(2 % accordionTriggers.length);

            //- TODO: recheck and improve loop to make it scalable
            if (i < 2 % accordionTriggers.length) {
                // console.log('condition #1: ' + i);

                item.attr('data-target', '.group1');
                content.addClass('group1');

                if (item.hasClass('collapsed')) {
                    item.removeClass('collapsed');
                    content.addClass('show');
                }

                if (item.attr('aria-expanded') == 'false') {
                    item.attr('aria-expanded', 'true');
                }

            } else {
                // console.log('condition #2: ' + i);

                item.attr('data-target', '.group2');
                content.addClass('group2');
            }
        })
    }

    if ($(window).outerWidth() > 1024) {
        accordionUI();
    }

    /**
     * consumptionLevels Slider
     */
    $('#consumptionLevelsSlide').slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false,
        infinite: false
    });

    /**
     * Reviews Slick
     */
    $('#reviewsList').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false
    });

    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
